import React, { useCallback, useMemo, useState } from 'react';
import { StyledFile } from './styles';

import { formatData } from '../../Utils/formatDate';

import { ReactComponent as ViewFileIcon } from '../../assets/novosicones/Sindico/ViewFile.svg';

import { Spinner } from '../StyledComponent';

export default function File({ style, file, onOpenFile }) {
  const [isLoading, setIsLoading] = useState(false);
  const uploadDateFormatted = useMemo(() => {
    if (file?.criado) {
      return formatData(file?.criado);
    }
  }, [file?.criado]);

  const openInNewTab = useCallback(async () => {
    setIsLoading(true);
    const urlToOpen = await onOpenFile(file);

    window.open(urlToOpen, '_blank');
    setIsLoading(false);
  }, [file]);

  return (
    <StyledFile style={style} $hasUrl={!!file?.urlAws} id={file?.id}>
      <button
        className='icon'
        onClick={openInNewTab}
        disabled={isLoading}
        title={'Visualizar arquivo'}
        $isLoading={isLoading}
      >
        {isLoading ? (
          <Spinner style={{ borderColor: '#003DA5' }} />
        ) : (
          <ViewFileIcon />
        )}
      </button>
      <button
        className='file-name'
        onClick={openInNewTab}
        disabled={isLoading}
        title={'Visualizar arquivo'}
      >
        {file?.nome}
      </button>

      <div className='container-infos-actions'>
        {uploadDateFormatted && (
          <span className='upload-status-file'>
            {`Upload em ${uploadDateFormatted}`}
          </span>
        )}
        <div className='file-actions'></div>
      </div>
    </StyledFile>
  );
}
